import { render, staticRenderFns } from "./AdShopTermsDialog.vue?vue&type=template&id=53a2e040&"
import script from "./AdShopTermsDialog.vue?vue&type=script&lang=js&"
export * from "./AdShopTermsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports